import Vue from 'vue';
import { getProducts } from '@breakmedia/prime-vue-product/src/store/getProducts';
import { Observable } from 'rxjs';
import { first } from 'rxjs/operators';

export const onBasketAdd = async function({ item, eventId }) {
    let product = item.product;
    if (!product) {
        product = await getProduct(item.product_id);
    }

    const products = [
        {
            ...Vue.$gtm.getProductObject(product, item),
            quantity: item.quantity,
        },
    ];

    // UA
    Vue.$gtm.push({
        event: 'addToCart',
        facebookEventID: eventId,
        ecommerce: {
            add: {
                products: products,
            },
            currencyCode: Vue.$currency.getSelected(),
        },
    });

    // GA4
    Vue.$gtm.push({
        event: 'add_to_cart',
        facebookEventID: eventId,
        ecommerce: {
            items: products,
            currency: Vue.$currency.getSelected(),
        },
    });
};

export const onBasketRemove = async function({ item, eventId }) {
    let product = item.product;
    if (!product) {
        product = await getProduct(item.product_id);
    }

    const products = [
        {
            id: item.product_id,
            ...Vue.$gtm.getProductObject(product),
            quantity: item.quantity,
        },
    ];

    // UA
    Vue.$gtm.push({
        event: 'removeFromCart',
        facebookEventID: eventId,
        ecommerce: {
            remove: {
                products: products,
            },
            currencyCode: Vue.$currency.getSelected(),
        },
    });

    // GA4
    Vue.$gtm.push({
        event: 'remove_from_cart',
        facebookEventID: eventId,
        ecommerce: {
            items: products,
            currency: Vue.$currency.getSelected(),
        },
    });
};

async function getProduct(productId) {
    if (Vue.$store.state.Basket.products[productId]) {
        return Vue.$store.state.Basket.products[productId];
    } else {
        return new Promise(resolve => {
            getProducts(
                new Observable(subscriber =>
                    subscriber.next({
                        ids: [productId],
                        priceParams: Vue.$basket.getPriceParams(Vue.$basket.getBasketItems()),
                    }),
                ),
            )
                .pipe(first())
                .subscribe(products => resolve(products));
        });
    }
}
